import React from 'react';
import { Outlet } from 'react-router-dom';

const VacancySettingsRouter: React.FC = () => {
  return <Outlet />;
};

export default VacancySettingsRouter;
